import Canjes from "./Canjes";
import { withRouter } from "react-router-dom";

export default withRouter(Canjes);
